export default function availableDocumentTypesResponse(response) {
    return response.map(i => ({
        label: `${i.module} / ${i.category_name} / ${i.document_type_name}`,
        uri: `${i.module_slug}/${i.category_slug}/${i.space_slug}`,
        value: i.document_type_id,
        isModal: i?.attributes?.modal,
        documentTypeName: i?.document_type_name,
        attributes: i?.attributes ?? {},
    }));
}